import api from '@api';
import { call, put, takeEvery } from 'redux-saga/effects';
import { getEgonDeliveriesFetchFailure, getEgonDeliveriesFetchSuccess } from './reducer';
import { EgonDeliveryType } from 'src/types/egonRoute';

const getEgonDeliveriesFetchRequest = async (): Promise<EgonDeliveryType[]> => {
    const res = await api<{ data: { deliveries: EgonDeliveryType[] } }>('get', 'api/secure/egon-routes/deliveries');
    return res.data.data?.deliveries || [];
};

function* getEgonDeliveriesFetch() {
    try {
        const response: EgonDeliveryType[] = yield call(getEgonDeliveriesFetchRequest);
        yield put(getEgonDeliveriesFetchSuccess(response));
    } catch (error) {
        yield put(getEgonDeliveriesFetchFailure());
    }
}

export function* getEgonDeliveriesFetchWatch() {
    yield takeEvery('egonDeliveries/getEgonDeliveriesFetch', getEgonDeliveriesFetch);
}
